"use client";

import { useRef, useState } from "react";
import useKeypress from "react-use-keypress";
import { Dialog, DialogBackdrop } from "@headlessui/react";
import { m, LazyMotion } from "motion/react";
import type { ImageProps } from "../utils/types";
import SharedModal from "./SharedModal";

const loadFeatures = () => import("components/Tiles/utils/motionFeatures").then((res) => res.default);

export default function Modal({
  images,
  onClose,
  photoId,
  onChangePhotoId,
  showAltLabel = false
}: {
  images: ImageProps[];
  onClose?: () => void;
  photoId: number;
  onChangePhotoId: (newVal: number) => void;
  showAltLabel?: boolean;
}) {
  const overlayRef = useRef(undefined);

  const index = Number(photoId);

  const [direction, setDirection] = useState(0);
  const [curIndex, setCurIndex] = useState(index);

  const handleClose = () => {
    onClose?.();
  };

  function changePhotoId(newVal: number) {
    if (newVal > index) {
      setDirection(1);
    } else {
      setDirection(-1);
    }
    setCurIndex(newVal);
    onChangePhotoId(newVal);
  }

  useKeypress("ArrowRight", () => {
    if (index + 1 < images.length) {
      changePhotoId(index + 1);
    }
  });

  useKeypress("ArrowLeft", () => {
    if (index > 0) {
      changePhotoId(index - 1);
    }
  });

  return (
    <Dialog
      static
      open
      onClose={handleClose}
      initialFocus={overlayRef as any}
      className="fixed inset-0 z-40 flex items-center justify-center"
    >
      <LazyMotion features={loadFeatures}>
        <DialogBackdrop
          ref={overlayRef as any}
          as={m.div}
          key="backdrop"
          className="fixed inset-0 z-40 bg-black/70 backdrop-blur-2xl"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        />
      </LazyMotion>
      <SharedModal
        index={curIndex}
        direction={direction}
        images={images}
        changePhotoId={changePhotoId}
        closeModal={handleClose}
        showAltLabel={showAltLabel}
        navigation
      />
    </Dialog>
  );
}
